import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'pur-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'pur-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'pur-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'pur-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'pur-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'pur-overview__activity--marketing-list',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'document',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

const databots = {
    activity: 'pur-overview__menu--activity',
    informations: 'pur-overview__menu--general-info',
    financialactivity: 'pur-overview__menu--financial-info',
    contacts: 'pur-overview__menu--contact-linked',
    addresses: 'pur-overview__menu--address',
    customfields: 'pur-overview__menu--cf',
    statistics: 'pur-overview__menu--stat',
    opportunity: 'pur-overview__menu--opportunity',
    estimate: 'pur-overview__menu--document',
    invoice: 'pur-overview__menu--document',
    delivery: 'pur-overview__menu--document',
    order: 'pur-overview__menu--document',
    creditnote: 'pur-overview__menu--document',
    proforma: 'pur-overview__menu--document',
    payments: 'pur-overview__menu--payment',
    bankaccount: 'pur-overview__menu--bank-account',
    recurring: 'pur-overview__menu--recurring',
    mandates: 'pur-overview__menu--mandate',
    timetracking: 'pur-overview__menu--timetracking',
    tickets: 'pur-overview__menu--ticket',
    project: 'pur-overview__menu--project',
    proposal: 'pur-overview__menu--proposal',
    emailingprofile: 'pur-overview__menu--mailing-list',
    massmailingMailinglist: 'pur-overview__menu--mailing-list',
    massmailingCampaignList: 'pur-overview__menu--mailing-list',
    receipts: 'pur-overview__menu--receipt',
    briefcase: 'pur-overview__menu--briefcase',
    activitycommentadd: 'pur-overview__activity--comment-add',
    emailadd: 'pur-overview__activity--email-add',
    calladd: 'pur-overview__activity--call-add',
    taskadd: 'pur-overview__activity--task-add',
    eventadd: 'pur-overview__activity--event-add',
    generalinfoedit1: 'pur-overview__section--general-info-edit-1',
    generalinfoedit2: 'pur-overview__section--general-info-edit-2',
    marketing: 'pur-overview__section--marketing',
};

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesTabs,
    defaultEntities,
    entitiesGroups,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
